<template>
    <div class='head'>

      <img :src='userInfo.avatar'/>
      <div class='name'>
          {{userInfo.name}}
      </div>
      <div class='posi'>
          {{userInfo.title}}
      </div>
      <div class='desv'>
          {{userInfo.introduction}}
      </div>
      <img src="../assets/delete.png" alt="" class='del' @click="dispear">
    </div>
</template>
<script>
export default {
  props:{
    userInfo:{
      name:'',
      position:'',
      desc:'',
      src:''
    }
  },

  data(){
      return {
        
      }
  },

  created(){
    //console.log('user',this.userInfo);
  },



  methods:{
    dispear(){
        this.$emit('dispear')
    }
  },

  mounted(){
    
  },

}
</script>
<style lang='less' scoped>
  div{
    text-align: center;
  }
  .name{
    width: 100px;
    margin-top: 10px;
    font-size: 17px;
  }
  .posi{
    width: 260px;
    margin-top: 10px;
    font-size: 16px;
  }

  .desv{
    padding: 8px 10px;
    margin-top: 15px;
    height:100px;
    font-size: 15px;
    overflow-y: auto;
  }

  .head{
    //       border: 1px solid #999;
    width: 340px;
    display: flex;
    height:420px;
    align-items: center;
    flex-direction: column;
    position: relative;
    img:nth-child(1){
      width:150px;
      height:180px;
      margin-top: 20px;
      object-fit: contain
    }
    .del{
      width:15px;
      height:15px;
      position:absolute;
      right:10px;
      top:10px;
    //   object-fit: contain
    }
  }
</style>


